import { STANDARD_BRANCH } from '@festina-life/api'
import { type ConfigurableServer, notEmpty } from '@festina-life/core'
import { useMemo } from 'react'

import { useFetchStandardComponentConcisePackage } from '../api/changesets/useFetchStandardComponentConcisePackage'
import type { ConciseChangesetWithBranchKey } from './types'

type Props = {
  server: ConfigurableServer
  enabled?: boolean
}

export const useStandardConciseChangesets = ({
  server,
  enabled = true,
}: Props): ConciseChangesetWithBranchKey[] => {
  const { data: standardConcisePackage } =
    useFetchStandardComponentConcisePackage({ server, enabled })

  return useMemo(
    () =>
      (standardConcisePackage?.changesets ?? [])
        .filter(notEmpty)
        .map((changeset) => ({
          ...changeset,
          branchKey: { server, name: STANDARD_BRANCH },
        }))
        .toReversed(), // the most recently applied changeset should be placed first,
    [server, standardConcisePackage?.changesets],
  )
}
